// libs
import React, { memo, useContext } from "react";
import styled from "@emotion/styled";

// global components
import { SubNavContext } from "shared/components/SubNav";
import HeaderSearch from "shared/components/HeaderSearch";

// styles
const Container = styled.div`
    display: flex;
    width: 320px;
    padding: 10px 20px;
    background: #fff;
    justify-content: space-between;
    align-items: center;
`;

function SearchInput() {
    const { doHide } = useContext(SubNavContext);

    return (
        <Container>
            <HeaderSearch onHide={doHide} showIcon={false} />
        </Container>
    );
}

export default memo(SearchInput);
